import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  tableHeadRow: {
    background: '#f0f0f0'
  },
  tableHeadCell: {
    textAlign: 'center',
    fontWeight: 'bold',
    minWidth: '180px'
  },
  tableRowCell: {
    height: '64px',
    textAlign: 'center'
  },
  buttonRemover: {
    color: 'green',
    fontWeight: 'bold'
  }
}));
